import { ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { Colors, ColorVariants } from './styles.types';

type ClsCategories = Record<string, string>;

export const clsCat = (categories: ClsCategories): string[] => Object.values(categories).map(String);

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const cnCat = (categories: ClsCategories) => cn(clsCat(categories));

export type Intent = 'text' | 'bg';

export const makeTailwindColor = (intent?: Intent) => (color: Colors, colorVariant?: ColorVariants) => {
  const fullColor = colorVariant ? `${String(color)}-${colorVariant}` : String(color);
  return `${intent}-${fullColor}`;
};

export const makeTailwindTextColor = makeTailwindColor('text');
